import { AuthContextInterface,withAuthContext } from '@amzn/awscat-react-components';
import { useEffect, useState } from 'react';

const Landing = (props: AuthContextInterface) => {
    const [token, setToken] = useState('');
    useEffect(() => {
        async function getToken() {
            const token: string = await props.auth.getToken(false);
            setToken(token);
        }
        getToken();
    });
    return (
        <div>
            <h1>Signed In</h1>
            <h2>token: {token}</h2>
        </div>
    );
};

export default withAuthContext(Landing);
